import _ from 'lodash';
import { PopPage } from './types';

class PopPageManager {
  public pageInstances: PopPage[] = [];

  public openPopPage(o: PopPage): Promise<unknown> {
    this.pageInstances.push(o);
    return o.open();
  }

  public addShowedPop(o: PopPage) {
    this.pageInstances.push(o);
  }

  public getShowedPopIndex() {
    if (!this.pageInstances.length) return -1;

    const lastOpenIndex = _.findLastIndex(this.pageInstances, (page) => page.isOpen);

    return lastOpenIndex;
  }

  public hasOpenedPopPage(): boolean {
    return this.getShowedPopIndex() >= 0;
  }

  public getShowedPopInstance() {
    const lastOpenIndex = this.getShowedPopIndex();

    return this.hasOpenedPopPage() ? this.pageInstances[lastOpenIndex] : undefined;
  }

  /** 调用弹框的挽回方法，在路由中调用 */
  public saveShowedPop() {
    const instance = this.getShowedPopInstance();

    if (instance && instance.save) {
      return instance.save();
    }

    return false;
  }

  public closeOneOpenedPage() {
    const lastOpenIndex = this.getShowedPopIndex();

    if (lastOpenIndex < 0) return false;

    this.pageInstances[lastOpenIndex].close();
    this.pageInstances.splice(lastOpenIndex - this.pageInstances.length);
    return true;
  }

  public saveOrCloseOpendPop() {
    const isSave = this.saveShowedPop();
    if (!isSave) {
      this.closeOneOpenedPage();
    }
  }
}

export const popPageManager = new PopPageManager();
